import styled from 'styled-components';

const ModalHeader = styled.div`
  background: #f6f6f6;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  padding: 10px 20px;
  border-bottom: 1px solid #cccccc;
`;

export default ModalHeader;
